import { Redirect } from "wouter";
import { canSeeFleet, landingPathFor } from "../auth/roleView";
import { useAuth } from "../auth/AuthContext";
import { HomePage } from "../features/home/HomePage";

/**
 * Renders what "/" shows for the signed-in role (IA slice 1,
 * docs/product/ui-information-architecture.md §3: "Home ← the `/` +
 * `/get-started` empty-state story").
 *
 * Every fleet role (admin/operator/viewer — `canSeeFleet`) renders Home
 * directly: Home's hero + three entry cards ARE the empty-state story for a
 * fresh tenant now (no separate first-run detour, no data-dependent
 * project/node-count check — the old M2 PR-1 behavior this replaced sent a
 * fresh tenant to `/get-started` and an established one to `/containers`;
 * Home now serves both, since it also shows Recent activity for a tenant
 * that already has some — see features/home/HomePage.tsx). `/get-started`
 * itself now redirects to `/` (App.tsx).
 *
 * `billing_admin` holds no fleet grants and would find nothing to click on
 * Home (every entry card lands on a page it has no access to) — it keeps
 * going straight to `/billing`, its one page, via the same pure
 * `landingPathFor(role)` as before.
 */
export function RoleLanding() {
  const { session } = useAuth();
  const role = session?.role;

  if (canSeeFleet(role)) {
    return <HomePage />;
  }

  return <Redirect to={landingPathFor(role)} />;
}
